<template>
  <CContainer>
    <Loader :is-processing="isLoading" />
    <CRow class="d-flex justify-content-center p-5">
      <CCol md="12" class="my-4 text-center">
        <h1 class="text-graident-blue">Kiosk Mode</h1>
      </CCol>
      <CCol
        col="12"
        sm="10"
        md="8"
        xl="6"
        class="kiosk-body p-4 text-center py-5"
      >
        <img
          src="@/assets/images/pass-color-logo.png"
          alt="pass-logo"
          class="mb-2 small-logo"
        />
        <h2 class="text-graident-blue text-value-lg text-center mb-3">
          TEACHER AUTHENTICATION
        </h2>

        <div class="max-w-400 m-auto">
          <CAlert
            v-if="reqResponse.message"
            class="mt-4 text-start"
            :color="reqResponse.type"
            :show="!!reqResponse.message"
          >
            {{ reqResponse.message }}
          </CAlert>
          <div class="form-group mb-0">
            <CFormInput
              type="password"
              class="mb-2"
              :is-valid="
                !v$.form.code.$error || !!reqResponse.errors['password']
              "
              v-model="form.code"
              placeholder="Code"
            />
            <div
              v-if="v$.form.$error && v$.form.code.required.$invalid"
              class="invalid-feedback d-block text-start m-0"
            >
              This field is required
            </div>
            <div
              v-if="reqResponse.errors['password']"
              class="invalid-feedback d-block text-start m-0"
            >
              {{ reqResponse.errors["password"][0] }}
            </div>
          </div>
          <div class="form-group mt-3 text-center">
            <div class="d-flex align-items-center justify-content-center">
              <div class="w-100" @click="login(null)">
                <CLoadingButton
                  ref="kioskloading"
                  :spinner="isLoading"
                  :disabled="isLoading"
                  :loading="isLoading"
                  class="me-2 btn bg-gradient-blue text-white w-100"
                >
                  Submit
                </CLoadingButton>
              </div>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import Loader from "@/components/Loader"
import useVuelidate from "@vuelidate/core"
import { required } from "vuelidate/lib/validators"
export default {
  name: "KioskLoginForm",
  components: {
    Loader
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isLoading: false,
      form: {
        code: null
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  computed: {
    isValid() {
      return !this.v$.form.$invalid
    }
  },
  mounted() {
    if (this.$route.query.code) {
      this.login(this.$route.query.code)
    } else {
      const directLoginToken = localStorage.getItem("kioskDirectLoginToken")
      if (directLoginToken) {
        this.login(directLoginToken)
      }
    }
  },
  validations: {
    form: {
      code: { required }
    }
  },
  methods: {
    login(code) {
      this.form.code = code ? code : this.form.code
      this.resetResponseMessages()
      if (this.isValid) {
        this.isLoading = true
        this.$store
          .dispatch("kiosks/directLogin", { passcode: this.form.code })
          .then((response) => {
            const data = response.data.data
            if (data) {
              this.$store.commit("kiosks/SET_ACTIVE_KIOSK", data)
              if (data.favorites && data.favorites.length) {
                const fav = JSON.parse(JSON.stringify(data.favorites))
                const favs = fav.sort((a, b) => {
                  return a.position - b.position
                })
                this.$store.commit("favorites/SET_FAVORITES", favs)
              }
            }
            localStorage.setItem("kioskDirectLoginToken", this.form.code) // added instead of access token impl
            this.$router.push("/kiosk/launch")
            this.resetForm()
            this.setSuccessResponse("Successfully Logged.")
            this.isLoading = false
          })
          .catch((err) => {
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
            this.isLoading = false
            this.form.code = ""
          })
      } else {
        this.v$.$touch()
      }
    },
    resetForm() {
      this.form = {
        code: null
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    }
  }
}
</script>

<style></style>
